import { motion } from "framer-motion";

type ProgressBarProps = {
  currentStep: number;
  totalSteps: number;
};

export default function ProgressBar({
  currentStep,
  totalSteps,
}: ProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="mb-8 w-full max-w-md">
      <div className="relative pt-1">
        <div className="flex h-2 overflow-hidden rounded-full bg-gray-200">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="h-full rounded-full bg-gradient-to-r from-green-600 to-green-800"
          ></motion.div>
        </div>
      </div>
      <p className="mt-2 text-center text-sm text-gray-600">
        Step {currentStep} of {totalSteps}
      </p>
    </div>
  );
}
